module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fi":{"closed":"Ravintola kiinni tänään","outsideCampus":"Ravintola sijaitsee kampuksen ulkopuolella"},"en":{"closed":"Restaurant closed today","outsideCampus":"Restaurant is not located in campus area"}}')
  delete Component.options._Ctor
}
